import { TypeBase } from './TypeBase'

export class ClientBase extends TypeBase {
  // previously was ma and ja
  constructor (type: 'client_0' | 'client_1' = 'client_0') {
    super(type)
  }
}
